<template>
  <li class="facet">
    <div v-if="!isSingleFilter" class="facet__tile" @click="toggleDropdown">
      <span>
        {{ transformFilterTitle(name) }}
      </span>
      <MinusIcon v-if="collapsed" />
      <PlusIcon v-else />
    </div>
    <div v-if="collapsed || isSingleFilter" class="facet__dropdown">
      <ul class="facet__dropdown__list">
        <li
          v-for="{ key, count } in visibleFilters"
          :key="key"
          :class="[
            'facet__dropdown__list__item',
            count === 0 && 'facet__dropdown__list__item--disabled',
            isSingleFilter && 'facet__dropdown__list__item-single',
          ]"
          @click="$emit('select-filter', { facet: name, value: key })"
        >
          <input
            class="facet__dropdown__list__item__checkbox"
            type="checkbox"
            :checked="checkedFilters.includes(key)"
            :disabled="count === 0"
          />
          <div class="facet__dropdown__list__item__label">
            <img
              v-if="icon"
              :src="icon"
              class="facet__dropdown__list__item-icon"
            />
            <span v-else>
              {{ transformFilterTitle(key) }}
            </span>
          </div>
          <span class="facet__dropdown__list__item__count">{{ count }}</span>
        </li>
      </ul>
      <button
        v-if="showMoreVisible"
        class="facet__dropdown__pill-btn"
        @click="showMore"
      >
        <span>
          Show more
        </span>
        <ChevronDownIcon size="16" />
      </button>
    </div>
  </li>
</template>

<script>
import { PlusIcon, MinusIcon, ChevronDownIcon } from 'vue-feather-icons'
import { mapState } from 'vuex'

export default {
  name: 'FacetDropdown',
  components: {
    PlusIcon,
    MinusIcon,
    ChevronDownIcon,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    checkedFilters: {
      type: Array,
      default: () => [],
    },
    icon: {
      type: String,
      default: () => '',
    },
    single: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => {
    return {
      collapsed: true,
      visibleQuantity: 5,
    }
  },
  computed: {
    ...mapState({
      filterMap: state => state.search.filterMap,
    }),
    showMoreVisible() {
      return this.filters.length > this.visibleFilters.length
    },
    visibleFilters() {
      return this.filters.slice(0, this.visibleQuantity)
    },
    filters() {
      const { data } = this

      return Object.keys(data).map(key => ({
        key,
        count: data[key],
      }))
    },
    isSingleFilter() {
      return this.single || false
    },
  },
  methods: {
    transformFilterTitle(filter) {
      return this.filterMap[filter] || filter
    },
    showMore() {
      this.visibleQuantity += 5
    },
    toggleDropdown() {
      this.collapsed = !this.collapsed
    },
  },
}
</script>

<style lang="scss" scoped>
.facet {
  display: flex;
  flex-flow: column;
  gap: 10px;
  color: var(--white);
  &__tile {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background: var(--glass-mid-gray);
    border-radius: 10px;
    font-family: var(--font-book);
    font-weight: 450;
    font-size: rem(16px);
    line-height: rem(24px);
  }
  &__dropdown {
    display: flex;
    flex-flow: column;
    align-items: center;
    gap: 10px;
    &__list {
      display: flex;
      align-self: stretch;
      flex-flow: column;
      padding: 0;
      font-family: var(--font-medium);
      font-weight: 500;
      font-style: normal;
      font-size: rem(14px);
      line-height: rem(20px);
      text-transform: capitalize;

      &__item {
        display: flex;
        align-items: center;
        gap: 12px;
        height: 40px;
        padding: 0 12px;
        border-bottom: 1px solid #2c2c31;
        cursor: pointer;
        &-single {
          border-top: 1px solid #2c2c31;
        }
        &--disabled {
          color: var(--mid-gray-dark);
          cursor: initial;
        }
        &__label {
          flex: 1;
          display: flex;
        }
        &-icon {
          width: 65%;
          max-width: 83px;
          flex: 1;
        }
        &__checkbox {
          border: 1px solid var(--white);
          width: 24px;
          height: 24px;
          border-radius: 8px;
          appearance: none;
          background: none;
          color: var(--white);
          padding: 11px;
          cursor: pointer;
          &:disabled {
            cursor: initial;
            border: 1px solid var(--mid-gray-dark);
          }
          &:checked {
            border: 1px solid var(--white);
            background: var(--white-10);
            color: var(--white);
            position: relative;
            display: inline-block;

            &::before {
              transform: rotate(40deg);
              content: '';
              position: absolute;
              width: 1px;
              height: 9px;
              background-color: var(--white);
              left: 12px;
              top: 6px;
            }
            &::after {
              transform: rotate(-45deg);
              content: '';
              position: absolute;
              width: 1px;
              height: 4px;
              background-color: var(--white);
              left: 8px;
              top: 10px;
            }
          }
        }
      }
    }
    &__pill-btn {
      display: flex;
      align-items: center;
      cursor: pointer;
      gap: 10px;
      border: none;
      padding: 6px 12px;
      border-radius: 40px;
      color: var(--white);
      background: var(--flat-black);
      font-family: var(--font-book);
      font-style: normal;
      font-weight: 450;
      font-size: rem(12px);
      line-height: rem(14px);
    }
  }
}
</style>
